import gql from "graphql-tag";
import { PriceRangeDisplay } from "graphql-client-product/fragments/price-range-display";
import { LineItem } from "graphql-client-product/fragments/pdp-line-item";
import { BaseProductFields } from "graphql-client-product/fragments/base-product-fields";
import { PersonalizeInfo } from "graphql-client-product/fragments/product";

export const ProductFields = gql`
  fragment ProductFields on Product {
    __typename
    ...BaseProductFields
    personalizeInfo {
      ...PersonalizeInfo
    }
    # relatedProducts {
    #   __typename
    #   ...BaseProductFields
    #   personalizeInfo {
    #     ...PersonalizeInfo
    #   }
    #   productLineItem(filter: $filter) {
    #     ...LineItem
    #   }
    # }
    productLineItem(filter: $filter) {
      ...LineItem
    }
    category
    spoReturnMessageOverride
    spoReturnMessageOverrideKey
    collectionName
    productDescription
    designerName
    customProductType
    swatchesToBuy {
      atgSkuId
      swatchId
      productId
      fullSkuId
    }
    carouselProdctDetails {
      imageUrl
      displayName
      productId
      sale
    }
    customProduct
    conciergeOnlyForNewPDP
    productOptionGroupBean {
      title
      optionsList
    }
    swatchBean {
      swatchId
      primaryOptionId
    }
    fullSkuId
    preSelectedOptions
    deliveryType
    eyebrow
    subHead
    subText
    build
    productStyle
    romanceHeader
    romanceSubheader
    romanceBody
    pdpQuantitySelectorVisible
    detailBody1
    detailBody2
    detailBody3
    detailHeader1
    detailHeader2
    detailHeader3
    dimensionLinkURL
    ctaLinks {
      layerType
      label
      leftCoordinate
      topCoordinate
      flyoutDirection
      htmlText
      shortText
      link
      modal
      path
    }
  }
  ${BaseProductFields}
  ${PriceRangeDisplay}
  ${PersonalizeInfo}
  ${LineItem}
`;
